import React, { useCallback, useEffect, useRef, useState } from 'react';
import Portal from './Portal';
import gomi from '../assets/bears/cards/gomi.png';
import bongbong from '../assets/bears/cards/bongbong.png';
import kongi from '../assets/bears/cards/kongi.png';
import nuri from '../assets/bears/cards/nuri.png';
import bandal from '../assets/bears/cards/bandal.png';

// An easter egg: click the bear beside a page's title five times in quick succession and the five Bear Patrol cards (the storyboard's cast) come out.
// The bear of the page you are on is raised in front of the others. Click anywhere, or press Escape, to put them away. Nothing hints at it.
const CARDS = [['gomi', gomi, 'Gomi, the Agent'], ['bongbong', bongbong, 'Bongbong, the Messenger'], ['kongi', kongi, 'Kongi, the Librarian'], ['nuri', nuri, 'Nuri, the Rule Keeper'], ['bandal', bandal, 'Bandal, the Security Guard']];
export const SECRET_CLICKS = 5;
export const SECRET_WINDOW_MS = 3000;

// Which card goes with a head: the dashboard's Kongi is Kongi.
const cardOf = (bear) => (bear === 'kongiDashboard' ? 'kongi' : bear);

// The click handler to put on the bear: true once the fifth click lands inside the window. The count starts again after it opens, and when a click
// comes after a pause.
export function useSecretClicks(onOpen, clicks = SECRET_CLICKS, windowMs = SECRET_WINDOW_MS) {
  const times = useRef([]);
  return useCallback(() => {
    const now = Date.now();
    times.current = [...times.current.filter((t) => now - t <= windowMs), now];
    if (times.current.length >= clicks) {
      times.current = [];
      onOpen();
    }
  }, [onOpen, clicks, windowMs]);
}

export default function BearCards({ featured, onClose }) {
  const mine = cardOf(featured);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <Portal>
      <div className="bear-cards" role="dialog" aria-label="The Bear Patrol" onClick={onClose}>
        <div className="bear-cards-row">
          {CARDS.map(([name, src, label], i) => (
            <img key={name} className={`bear-card${name === mine ? ' featured' : ''}`} src={src} alt={label} style={{ '--i': i }} />
          ))}
        </div>
      </div>
    </Portal>
  );
}

// The bear of a page title with the egg built in: the caller shows <BearCards> when `open` is true.
export function useBearEgg() {
  const [open, setOpen] = useState(false);
  const onClick = useSecretClicks(useCallback(() => setOpen(true), []));
  return { open, onClick, close: useCallback(() => setOpen(false), []) };
}
